module.exports = __webpack_public_path__ + "static/media/user-crown.bb96aa30.svg";